module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Add Video")]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('form', [_c('p', {
    staticClass: "field flex-space-between flex-align-center"
  }, [_c('input', {
    staticClass: "button is-primary",
    attrs: {
      "value": "Upload Video",
      "type": "button",
      "disabled": _vm.fileUploaded
    },
    on: {
      "click": function($event) {
        _vm.showUploader()
      }
    }
  }), _vm._v(" "), (_vm.fileUploaded) ? _c('span', [_c('span', {
    staticClass: "is-success"
  }, [_vm._v("Uploaded:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.title))])]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "title is-2 input",
    attrs: {
      "placeholder": "video title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "subtitle textarea",
    attrs: {
      "placeholder": "Add video description"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hideCycles),
      expression: "!hideCycles"
    }]
  }, [_c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("Cycles")]), _vm._v(" "), (_vm.cycles.length > 0) ? _c('ul', _vm._l((_vm.cycles), function(cycle) {
    return _c('li', {
      staticClass: "panel-block flex-space-between"
    }, [_c('div', {
      staticClass: "flex-align-center"
    }, [_c('router-link', {
      attrs: {
        "to": "/cycles"
      }
    }, [_vm._v(_vm._s(cycle.title))]), _vm._v(" "), (cycle.id === _vm.cycleID) ? _c('p', {
      staticClass: "current-cycle"
    }, [_vm._v("(current cycle)")]) : _vm._e()], 1), _vm._v(" "), _c('input', {
      ref: "cycleRadio",
      refInFor: true,
      attrs: {
        "name": "cycle",
        "type": "radio",
        "id": cycle.id
      },
      domProps: {
        "checked": cycle.id === _vm.cycleID || _vm.videoInCycle(cycle, _vm.videoID)
      }
    })])
  })) : _c('p', [_vm._v("\n            No cycles found.\n          ")])]), _vm._v(" "), (_vm.isCoach && _vm.userID) ? _c('p', {
    staticClass: "uploadfor flex-align-center"
  }, [_c('label', [_vm._v("Video Owner: ")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.owner),
      expression: "owner"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.owner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.teachers), function(t) {
    return _c('option', {
      domProps: {
        "value": t.id
      }
    }, [_vm._v(_vm._s(t.name || t.email))])
  }))])]) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary",
    class: _vm.loading && 'is-loading',
    attrs: {
      "disabled": !_vm.fileUploaded
    },
    on: {
      "click": function($event) {
        _vm.createVideo()
      }
    }
  }, [_vm._v("Send to Processing")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-52d78421"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddVideoModal.vue
// module id = 1037
// module chunks = 0